import React, { Component } from 'react';
import './CheckboxFilterOption.css';
import ParameterErrors from '../errors/ParameterErrors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class KeyboardButton extends Component {
	constructor(props){
		super(props);
		const {value, icon, imgUrl, text, onClick}=props;
		if(value===undefined)throwNotProvided('value');
		this._value = value;
		
		const textNotProvided=(text===undefined||text===null);
		const iconNotProvided = (icon===undefined||icon===null);
		const imgNotProvided = (imgUrl===undefined||imgUrl ===null);
		if(textNotProvided&&iconNotProvided&&imgNotProvided)throwNotProvided('text or icon or imgUrl');
		if(!textNotProvided){
			if(typeof(text)!=='string')throwNotOfType('text', 'string');
		}
		this._text = text;
		this._icon = icon;
		this._imgUrl = imgUrl;
		
		if(onClick===undefined||onClick===null)
			throwNotProvided('onClick');
		
		if(typeof(onClick)!=='function')
			throwNotOfType('onClick', 'function');
		this._callbackClick = onClick;
		
		this._handleClick = this._handleClick.bind(this);
	}
	_handleClick(){
		this._callbackClick(this._value);
	}
	render() {
		const content = this._text?this._text:(
		this._imgUrl? (<img src={this._imgUrl}></img>):(<FontAwesomeIcon icon={this._icon}></FontAwesomeIcon>));
		return (<button className="keyboard-button" onClick={this._handleClick}>{content}</button>);
	}
}
